// extracted by mini-css-extract-plugin
export default {"city":"display_city__Hj4KM","address2":"display_address2__9ZaFc"};